var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('h1',[_vm._v("Willkommen")]),_c('div',[_vm._v(" Dies sind die Pen&Paper Utilities. Hier ein kurzer Überblick: "),_c('v-flex',[_vm._v(" Aktueller Kampf: "+_vm._s(_vm.currentFight)+" ")])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }